import { render, staticRenderFns } from "./PeerGroupBatchDialog.vue?vue&type=template&id=53c71158&scoped=true&"
import script from "./PeerGroupBatchDialog.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupBatchDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupBatchDialog.vue?vue&type=style&index=0&id=53c71158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c71158",
  null
  
)

export default component.exports